import {Component, computed, input} from '@angular/core';
import {Button} from 'primeng/button';
import {CreateTaStepType} from '../../../../util/app.types';
import {CreateTaBaseComponent} from '../create-ta-base-component.directive';

@Component({
  selector: 'create-ta-title-bar',
  imports: [
    Button
  ],
  templateUrl: './create-ta-title-bar.component.html',
  styleUrl: './create-ta-title-bar.component.scss'
})
export class CreateTaTitleBarComponent extends CreateTaBaseComponent {
  stepTitle = input<string>('');

  submissionId = computed<string>(() => {
    if (this.store.taSubmission()?.id) {
      return this.store.taSubmission()!.id!.toString();
    } else {
      return 'new';
    }
  });

  canContinue = computed<boolean>(() => {
    const current = this.store.currentCreateTaStep();
    this.taSubmissionDatasource.calculateCurrentStepValid();
    return current?.valid ?? false;
  });
  canGoBack = computed<boolean>(() => {
    return this.store.currentCreateTaStep()?.code !== CreateTaStepType.TRAVELLERS;
  });

  goBack(): void {
    this.router.navigate(['/ta/' + this.submissionId()], {
      queryParams: { step: this.getNewStep('decrement') },
      queryParamsHandling: 'merge',
    });
  }

  saveAndContinue() : void {
    // this.taSubmissionDatasource.updateServerTaSubmission();

    let nextStep = this.getNewStep('increment');
    if (nextStep === 'review') {
      this.router.navigate(['ta/' + this.submissionId() + '/review']);
    } else {
      this.router.navigate(['/ta/' + this.submissionId()], {
        queryParams: { step: nextStep},
        queryParamsHandling: 'merge',
      });
    }
  }

  getNewStep(direction: 'increment' | 'decrement'): CreateTaStepType | undefined {
    const modifier: number = (direction === 'increment') ? 1 : -1
    const steps = this.store.createTaSteps();
    const currentIndex = steps.indexOf(this.store.currentCreateTaStep());
    const newIndex = Math.max(0, Math.min(currentIndex + modifier, steps.length-1));
    return steps[newIndex].code;
  }

}
